module.exports = __webpack_public_path__ + "static/img/music.be7d60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/music.png
// module id = 8vlb
// module chunks = 4